module.exports = __webpack_public_path__ + "static/media/sprites_2x.2bed5b85.png";